/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { CardAttr } from '../widgets/card-attr';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { colors } from '../../themes';

const ProviderContainer = styled.section`
  margin-bottom: 10px;
  h2 {
    padding: 0;
    margin: 0em 0em 0.5em;
  }
  > span {
    font-size: 0.9em;
    color: ${colors.baseColors.grey};
  }
`;
function $CurrentServiceProviderCard(props: any) {
  if (!props.provider) {
    return null;
  }
  return (
    <ProviderContainer>
      <span>Service Provider</span>
      <h2>{props.provider.name}</h2>
      <CardAttr title="Code">{props.provider.code}</CardAttr>
    </ProviderContainer>
  );
}

export const CurrentServiceProviderCard = connect((s: any) => ({
  provider: s.serviceProviders.myProvider
}))($CurrentServiceProviderCard);
